import * as yup from "yup";

import MediaTypes from "../../types/mediaTypes";
import { PostProcessingTimeout, SLAEvaluationInterval } from "./constants";

export default () =>
  yup.object().shape({
    media_type: yup.string().nullable().oneOf(Object.values(MediaTypes)),
    id: yup.string().nullable(),
    name: yup.string().required(),
    is_enabled: yup.boolean().required(),
    default_priority: yup.number().min(1).max(10).required(),
    default_interaction_priority: yup.number().min(1).max(100).required(),
    post_processing_timeout: yup
      .number()
      .oneOf(Array.from(Object.values(PostProcessingTimeout)))
      .required(),
    sla_interaction_percentage: yup.number().min(1).max(100).required(),
    sla_interaction_time: yup.number().required(),
    sla_evaluation_interval: yup
      .number()
      .oneOf(Array.from(Object.values(SLAEvaluationInterval)))
      .required(),
    sla_notification_enabled: yup.boolean().required(),
    description: yup.string().nullable(),
  });
